import CheckIcon from '@mui/icons-material/Check';
import ZuiList from '@zenbusiness/zui/List';
import ZuiListItem from '@zenbusiness/zui/ListItem';
import ListItemIcon from '@zenbusiness/zui/ListItemIcon';
import { superstyled } from '@zenbusiness/zui/styles';
import Text from '@zenbusiness/zui/Text';

export const IconStep = superstyled({
  tag: ListItemIcon,
  name: 'Information',
  slot: 'IconStep',
  styles: ({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minWidth: '2rem',
    height: '2rem',
    borderRadius: theme.shape.rounded.full,
    backgroundColor: theme.palette.fixed.black,
    color: theme.palette.fixed.white,
    fontSize: '0.75rem',

    [theme.breakpoints.up('md')]: {
      minWidth: '2.5rem',
      height: '2.5rem',
      fontWeight: 'bold',
      fontSize: '1rem',
    },
  }),
});

export const Description = superstyled({
  tag: Text,
  name: 'Information',
  slot: 'Description',
  styles: ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    wordBreak: 'break-word',
    whiteSpace: 'normal',
  }),
});

export const Disclaimer = superstyled({
  tag: Text,
  name: 'Information',
  slot: 'Disclaimer',
  styles: ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    wordBreak: 'break-word',
    whiteSpace: 'normal',
  }),
});

export const SubDescription = superstyled({
  tag: Text,
  name: 'Information',
  slot: 'SubDescription',
  styles: ({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
  }),
});

export const StyledCheckIcon = superstyled({
  tag: CheckIcon,
  name: 'Information',
  slot: 'CheckIcon',
  styles: () => ({
    width: '1rem',
    height: '1rem',
  }),
});

export const List = superstyled({
  tag: ZuiList,
  name: 'Information',
  slot: 'List',
  styles: ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
  }),
});

export const ListItem = superstyled({
  tag: ZuiListItem,
  name: 'Information',
  slot: 'ListItem',
  styles: () => ({
    padding: 0,
  }),
});
